<template>
  <v-card>
    <v-toolbar
      color="primary darken-2"
      dark
      dense>
      <v-toolbar-title class="text-xs-center">Vehículos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary darken-1"
        small
        @click="setHeatMapDialog(true)"
      >
        <v-icon left size="16">
          map
        </v-icon>
        Ver Mapas
      </v-btn>
    </v-toolbar>

    <!-- <vehicles-filter :mapRef="mapref" v-show="showFilters"/> -->

    <v-flex ma-2 pl-3>
      <h4 class="py-2">Total Vehículos: {{ lastPositionsInit.length }}</h4>
      <v-divider></v-divider>
      <v-flex d-inline-flex align-center>
        <v-flex>
          <h4 class="py-2">Vehículos en Mapa:</h4>
        </v-flex>
        <v-flex v-if="isFiltering" pl-1>
          <v-progress-circular
            :size="24"
            :width="2"
            color="primary"
            indeterminate
          />
        </v-flex>
        <v-flex v-else pl-1>
          <h4 class="py-2">{{ currentMarkersLength }}</h4>
        </v-flex>
      </v-flex>
    </v-flex>

    <v-divider></v-divider>
    <!-- MAP OPTIONS -->
    <v-flex
      class="margin-bottom-section"
      px-3
      pt-2
    >
      <h3>Opciones de Mapa</h3>
      <v-flex
        class="margin-top-section"
        d-inline-flex
      >
        <v-flex>
          <v-checkbox
            v-model="showTraffic"
            label="Ver tráfico"
            @change="toggleTraffic"
          ></v-checkbox>
        </v-flex>
        <!-- <v-flex pl-4>
          <v-checkbox
            v-model="showCameras"
            label="Ver Cámaras"
            @change="showCamerasEventIn"
          ></v-checkbox>
        </v-flex> -->
      </v-flex>
    </v-flex>
    <v-divider></v-divider>
    <!-- CITY OFICIAL LAYERS -->
    <v-flex
      class="margin-bottom-section"
      px-3
      pt-2
    >
      <v-select
        v-model="cityLayer"
        :items="layerCityOptions"
        item-text="text"
        item-value="value"
        box
        label="Capas Ciudad"
        @change="$nextTick(() => { displayCitiLayer(cityLayer) })"
      ></v-select>
    </v-flex>
    <v-divider></v-divider>
    <!-- SEARCH VEHICLE -->
    <v-flex
      d-inline-flex
      px-3
      pt-3
      :class="[notFoundResult ? notFound : '']"
      class="margin-bottom-section"
    >
      <v-flex>
        <v-text-field
          v-model="searchVehicleValue"
          label="Código/Sigla ó Placa"
          style="width: 270px;"
          :disabled="searchDisabled"
          color="white"
          ref="search"
          flat
          box
          prepend-inner-icon="search"
          @keyup.enter="searchVehicle"
        ></v-text-field>
      </v-flex>
      <!-- CLEAR SEARCH BUTTON -->
      <v-flex>
        <v-btn
          color="primary"
          fab
          small
          depressed
          :disabled="!showClearSearchBtn"
          @click="clearFilterSearchIn"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
    <!-- VEHICLE CONDITION AND SERVICE FILTER -->
    <v-flex class="bg-filter-condition">
      <v-flex d-flex px-1>
        <!-- CONDITION -->
        <v-flex>
          <v-select
            v-model="filterConditionIn"
            label="Condición"
            class="compact-form"
            color="white"
            clearable
            box
            :items="itemsFilterCondition"
            @change="clearFilter"
          ></v-select>
        </v-flex>
        <!-- SERVICE -->
        <v-flex>
          <v-select
            v-model="filterInMissionIn"
            label="Misión"
            style="margin-left:-20px"
            class="compact-form"
            item-value="value"
            item-text="text"
            color="white"
            clearable
            box
            :items="itemsInMission"
            @change="clearFilter"
          ></v-select>
        </v-flex>
        <!-- @change="listCondition" -->
      </v-flex>
    </v-flex>

    <v-flex
      class="text-xs-center header-vehicle"
      align-center
      d-flex
      pr-3>
      <v-flex xs5>
        Código/Sigla
      </v-flex>
      <v-flex xs4>
        Placa
      </v-flex>
      <v-flex xs3>
        Estado
      </v-flex>
    </v-flex>

    <RecycleScroller
      v-if="!isFiltering"
      :buffer="250"
      class="list-vehicles"
      :items="vehicleList"
      :item-size="41"
      key-field="id"
      v-slot="{ item }">
      <v-flex
        class="text-xs-center pointer-1 vehicle-list-style"
        :class="setActiveVehicleList(item)"
        align-center
        d-flex
        @click="handleShowVehicleInformation(item)">
        <v-flex xs5>
          {{ item.code}}
        </v-flex>
        <v-flex xs4>
          <v-flex :class="lastPositionFiltered.find(itemIn => itemIn.id === item.id) ? 'plate-active' : 'plate-off'">
            {{ item.licensePlate }}
          </v-flex>
        </v-flex>
        <v-flex xs3>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-icon
                :color="stateColor(item).color"
                size="21"
                v-on="on">
                lens
              </v-icon>
            </template>
            <span>
              <v-icon size="12px">access_time</v-icon>
              Tiempo detenido:
              <v-flex d-inline-flex>
                <v-flex>
                  <b>
                    <h6>
                      {{ stateColor(item).amountStoppedTime }}
                    </h6>
                  </b>
                </v-flex>
                <v-flex v-if="stateColor(item).amountStoppedTime !== 'Estático'" pl-1>
                  minutos.
                </v-flex>
              </v-flex>
            </span>
            <br>
            <span>
              <v-icon size="12px">event</v-icon>
              Inicio estacionaria:
              <v-flex d-inline-flex>
                <v-flex>
                  <b>
                    <h6>
                      {{ stateColor(item).stoppedSince === '' ? 'NA' : stateColor(item).stoppedSince | filterFullDate }}
                    </h6>
                  </b>
                </v-flex>
              </v-flex>
            </span>
            <br>
            <span>
              <v-icon size="12px">event</v-icon>
              Cambio a estado
              <v-flex d-inline-flex align-center>
                <v-flex>
                  <b>
                    <h6>
                      {{ stateColor(item).indexState }}
                    </h6>
                  </b>
                </v-flex>
              <!-- <v-flex d-inline-flex> -->
                <v-flex>
                  <b>
                    <h6>
                      : {{ stateColor(item).changeStateAt === 'Invalid date' ? 'NA' : stateColor(item).changeStateAt | filterFullDate }}
                    </h6>
                  </b>
                </v-flex>
              </v-flex>
            </span>
          </v-tooltip>
        </v-flex>
      </v-flex>
    </RecycleScroller>
    <v-flex v-else class="text-xs-center" py-5>
      <v-progress-circular
        :size="36"
        :width="4"
        color="primary"
        indeterminate
      />
    </v-flex>
    <v-progress-linear indeterminate v-if="$loading.isLoading('fetchingVehicles')"/>
  </v-card>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import VehiclesFilter from './VehiclesFilter'
  import { vehicleStatesMixin } from '../mixins/vehicleStatesMixin.js'

  import {gmapApi} from 'vue2-google-maps'

  import zoomMapBoundaries from '../utils/zoomMapBoundaries'
  /**
   * Componente que lista los vehiculos
   *
   * @author Manuel Ochoa
   */
  export default {
    name: 'app-list-vehicles',
    mixins: [vehicleStatesMixin],
    components: {
      VehiclesFilter
    },
    props: {
      mapref: {
        type: Object
      },
      trafficlayer: {
        type: Object
      }
    },
    data() {
      return {
        itemsInMission: [
          { value: '0', text: 'Sin asignar' },
          { value: '1', text: 'En servicio' }
        ],
        firstLoad: false,
        workerList: null,
        vehicleList: [],
        itemsFilterCondition: [
          'Operativo',
          'No operativo',
          'Por identificar'
        ],
        // filterCondition: 'Todos',
        cityLayer: 0,
        layerCityOptions: [
          { text: 'Sin capas', value: 0 },
          { text: 'Malla vial', value: 1 }
          // { text: 'Puntos de interés', value: 2 }
        ],
        showCameras: false,
        trafficLayer: null,
        showTraffic: false,
        searchDisabled: false,
        notFound: 'not-found',
        notFoundResult: null,
        model1: 'Hola',
        searchVehicleValue: null,
        /**
         * Controla la visibilidad de los filtros por zonas de los vehiculos
         *
         * @type {boolean}
         */
        showFilters: false
      }
    },
    watch: {
      lastPositionFiltered(newValue, oldValue) {
        if (newValue.length > 0 && newValue.length !== oldValue.length) {
          // console.log('apply F 1')
          this.applyFilterCondition()
        }
      },
      showClearFilterBtn(newValue) {
        // console.log('showClearFilterBtn', newValue, oldValue)
        if (!newValue) {
          // console.log('apply F 2')
          this.applyFilterCondition()
        }
      },
      inMissionFilter(newValue, oldValue) {
        // console.log('inMissionFilter', newValue, oldValue)
        // console.log('apply F 3')
        this.applyFilterCondition()
      },
      vehicleList(newValue, oldValue) {
        // console.log('VEHICLE LIST', newValue, oldValue)
      },
      lastPositionSearch(newValue, oldValue) {
        if (newValue.length > 0) this.vehicleList = newValue
        else {
          // console.log('apply F 4')
          this.applyFilterCondition()
        }
      },
      filterByAZ(newValue) {
        // console.log('FILTER BY AZ: ', newValue, oldValue)
        if (newValue) {
          // console.log('apply F 5')
          this.applyFilterCondition()
        }
      },
      lastPositionsInit(newValue, oldValue) {
        if (this.firstLoad === false && newValue !== oldValue && newValue.length > 0) {
          // console.log('WATCH lastPositionsInit', newValue, oldValue)
          this.showInitDialogAction(false)
          this.displayFiltersHome(true)
          this.vehicleList = newValue
          this.firstLoad = true
        }
      },
      filterCondition(newValue, oldValue) {
        // console.log('apply F 6')
        this.applyFilterCondition()
      }
    },
    computed: {
      google: gmapApi,
      ...mapGetters([
        'isFiltering',
        'inMissionFilter',
        'lastPositionSearch',
        'filterByAZ',
        'lastPositionFilteredCondition',
        'currentMarkersLength',
        'filterCondition',
        'getFilteredVehicles',
        'getSelectedVehicle',
        'lastPositionsInit',
        'lastPositionFiltered',
        'showClearFilterBtn',
        'showClearSearchBtn'
      ]),
      ...mapGetters({
        role: 'auth/role',
        adminRole: 'auth/adminRole'
      }),
      filterInMissionIn: {
        get() {
          return this.inMissionFilter
        },
        async set(value) {
          if (value === undefined) value = null
          if (value !== null) {
            // console.log('BEFORE AWAIT processInMissionData', value)
            await this.processInMissionData()
            // console.log('AFTER AWAIT processInMissionData')
          }
          this.setInMissionFilter(value)
        }
      },
      filterConditionIn: {
        get() {
          return this.filterCondition
        },
        set(value) {
          if (value === undefined) value = null
          this.updateFilterCondition(value)
          // Set log with the option selected
          if (value !== null) {
            const payload = {
              event: 'searched',
              eventDescription: 'filters',
              dataAction: value,
              modelId: '',
              modelType: 'vehicle status',
              product: 'front-preloaded-data-filter'
            }
            this.setLogHistoryFront(payload)
          }
        }
      }
    },
    methods: {
      ...mapActions([
        'processInMissionData',
        'setIsFiltering',
        'setInMissionFilter',
        'displayFiltersHome',
        'showInitDialogAction',
        'agencySelectedAction',
        'clearSearch',
        'setFilterByAZ',
        // 'setFilterConditionAll',
        'setFilterCondition',
        'updateFilterCondition',
        'searchVehicleAction',
        'setSearchedVehicleAction',
        'selectVehicle',
        'clearFilterSearch',
        'displayCitiLayer',
        'setLogHistoryFront',
        'setHeatMapDialog',
        'setInfoWinOpen'
      ]),
      fitBoundsFilters(filterVehicles) {
        // console.log('FIT BOUNDS FILTERS', filterVehicles.length, this.showClearFilterBtn)
        const bounds = new google.maps.LatLngBounds()
        filterVehicles.forEach(element => {
          bounds.extend(element.location)
        })
        // console.log('BOUNDS', bounds)
        if (filterVehicles.length > 0) {
          const area = zoomMapBoundaries(bounds)
          if (area > 100000) {
            // console.log('Area > 100000')
            const extraPadding = 110
            this.mapref.fitBounds(bounds, extraPadding)
          } else {
            // console.log('Area <= 100000')
            const extraPadding = 100
            this.mapref.fitBounds(bounds, extraPadding)
            this.mapref.setZoom(17)
          }
        } else if (!this.filterByAZ) {
          bounds.extend({lat: 6.254790211409118, lng: -75.551029793457})
          this.mapref.fitBounds(bounds)
          this.mapref.setZoom(13)
        }
      },
      setActiveVehicleList(item) {
        let obj = this.lastPositionSearch > 0 ? this.lastPositionSearch : this.lastPositionFiltered
        const result = obj.find(itemIn => itemIn.id === item.id) ? 'info-vehicle-active' : 'info-vehicle-off'
        return result
      },
      applyFilterCondition() {
        if (this.lastPositionSearch.length > 0) return true

        this.setIsFiltering(true)

        let currentData = []
        this.vehicleList = []

        if (this.filterByAZ) {
          currentData = this.lastPositionFiltered
        } else {
          currentData = this.lastPositionsInit
        }

        // console.log('CURRENT DATA', currentData, this.filterByAZ, this.lastPositionFiltered)

        if (!this.filterCondition && !this.inMissionFilter) {
          this.vehicleList = currentData
          if (!this.filterByAZ) {
            this.setFilterCondition([])
            // console.log('1')
            this.fitBoundsFilters([])
          } else {
            // console.log('2')
            this.fitBoundsFilters(currentData)
          }
          this.setIsFiltering(false)
        } else {
          if (this.filterCondition) {
            this.workerList.postMessage('filterList', [currentData, this.filterCondition])
              .then(resultFW => {
                // console.log('RESULT filterList: ', resultFW.length)
                this.vehicleList = resultFW
                this.setFilterCondition(resultFW)
                // console.log('3')
                this.fitBoundsFilters(resultFW)

                if (this.inMissionFilter) {
                  // if (this.vehicleList.length > 0) currentData = this.vehicleList
                  currentData = this.vehicleList
                  // console.log('currentData', currentData)
                  this.workerList.postMessage('inMissionList', [currentData, this.inMissionFilter])
                    .then(resultIFM => {
                      // console.log('RESULT inMissionList: ', resultIFM.length)
                      this.vehicleList = resultIFM
                      this.setFilterCondition(resultIFM)
                      // console.log('4')
                      this.fitBoundsFilters(resultIFM)
                      this.setIsFiltering(false)
                    })
                } else this.setIsFiltering(false)
              })
              .catch(error => {
                console.error('WORKER ERROR :', error)
                this.setIsFiltering(false)
              })
          } else if (this.inMissionFilter) {
            // console.log('currentData Before', currentData)
            if (this.vehicleList.length > 0) currentData = this.vehicleList
            // console.log('currentData', currentData)
            this.workerList.postMessage('inMissionList', [currentData, this.inMissionFilter])
              .then(resultIFM => {
                // console.log('RESULT else if inMissionList: ', resultIFM.length)
                this.vehicleList = resultIFM
                this.setFilterCondition(resultIFM)
                // console.log('5')
                this.fitBoundsFilters(resultIFM)
                this.setIsFiltering(false)
              })
              .catch(error => {
                console.error('WORKER inMissionList ERROR :', error)
                this.setIsFiltering(false)
              })
          }
        }
      },
      showCamerasEventIn() {
        this.$emit('showCamerasEvent', this.showCameras)
      },
      toggleTraffic() {
        // this.trafficlayer = new this.google.maps.TrafficLayer()
        // console.log('TRAFFIC LAYER: ', this.trafficlayer)
        if (this.showTraffic) this.trafficlayer.setMap(this.mapref)
        else this.trafficlayer.setMap(null)
      },
      clearFilterSearchIn() {
        this.searchDisabled = false
        this.$refs.search.reset()
        this.searchResult = []
        this.clearSearch(this.mapref)
        this.setInfoWinOpen(false)
      },
      searchVehicle() {
        // console.log('SEARCH', this.searchVehicleValue)
        if (this.searchVehicleValue !== null) {
          // this.searchAction = false
          this.searchVehicleAction(this.searchVehicleValue)
            .then(result => {
              // this.$refs.search.reset()
              // console.log('RESULT', result)
              this.searchResult = result
              if (result.length > 0) {
                // this.clearFilterSearch(this.mapref)
                this.searchDisabled = true
                this.setSearchedVehicleAction(result)
                // console.log('6')
                this.fitBoundsFilters(result)
                // Set log with the search result
                const payload = {
                  event: 'searched',
                  eventDescription: 'finder',
                  dataAction: result[0],
                  modelId: result[0].id,
                  modelType: 'home',
                  product: 'front-preloaded-data-search'
                }
                this.setLogHistoryFront(payload)
              } else {
                this.notFoundResult = true
                this.searchDisabled = true
                setTimeout(() => {
                  this.notFoundResult = null
                  this.searchDisabled = false
                }, 1000)
              }
            })
        }
      },
      /**
       * Metodo que selecciona un vehiculo en Vuex y luego emite un evento de centrado que recibe con la ultima posicion del vehiculo
       * @param vehicle
       */
      handleDisplayVehicle(vehicle) {
        this.selectVehicle(vehicle)
        // let {lastPosition} = vehicle
        this.$emit('centerMarker', {
          lat: vehicle.lastPosition.lat,
          lng: vehicle.lastPosition.lng
        })
      },
      /**
       * Metodo que selecciona un vehiculo en Vuex y luego va a la vista del vehiculo
       *
       * @param vehicle
       */
      handleShowVehicleInformation(vehicle) {
        // console.log('VEHICLE INIT: ', vehicle)
        this.selectVehicle(vehicle)
        this.$router.push({name: 'AppVehicleViwer', params: {vehicle_id: vehicle.id}})
      },
      /**
       * Metodo que devuelve el nombre de las clases pertinentes para resaltar el vehiculo seleccionado en la lista de vehiculos
       *
       * @param vehicle
       * @returns {*}
       */
      highlightVehicle(vehicle) {
        if (this.getSelectedVehicle !== null) {
          return {
            'primary darken-4': vehicle.id === this.getSelectedVehicle.id
          }
        }
        return {}
      },
      clearFilter() {
        this.setInfoWinOpen(false)
      }
    },
    created() {
      const actions = [
        {
          message: 'filterList',
          func: (data, condition) => {
            const result = []
            for (let index = 0; index < data.length; index++) {
              const element = data[index]
              const match = element.status.translatedName === condition
              if (match) result.push(data[index])
            }
            return result
          }
        },
        {
          message: 'inMissionList',
          func: (data, condition) => {
            const result = []
            for (let index = 0; index < data.length; index++) {
              const element = data[index]
              const match = element.inMission === condition
              if (match) result.push(data[index])
            }
            return result
          }
        }
      ]

      this.workerList = this.$worker.create(actions)
      // this.listCondition()
    }
  }
</script>

<style lang="stylus" scoped>
h6
  font-size 14px

.compact-form
  transform scale(0.85)
  transform-origin left
  width 195px

.bg-filter-condition
  background-color #212121

.width-in-component
  width 500px

.scale-component
  // min-width 400px
  margin-top -40px
  transform scale(0.5)
  transform-origin left

.margin-bottom-section
  margin-bottom -15px

.margin-top-section
  margin-top -15px

.vehicle-list-style
  height 40px
  margin-bottom 1px

.hover .vehicle-list-style
  opacity 0.7

.header-vehicle
  background-color #212121
  height 30px
  margin-top -20px
  margin-bottom 1px

.info-vehicle-active
  background-color #212121
  height 40px
  margin-bottom 1px
  border-left 7px solid #2196F3

.info-vehicle-off
  background-color #212121
  height 40px
  margin-bottom 1px

.plate-active
  border 2px solid #2196F3
  border-radius 5px
  background-color #2196F3

.plate-off
  border 2px solid grey
  border-radius 5px

.pointer-1
  cursor pointer

// .pointer-1:hover
//   opacity 0.7

.list-vehicles
  height calc(100vh - 550px)
  overflow-y scroll

.not-found
  animation: bounce 0.8s ease-out;

@keyframes bounce {
  0% {
	transform:translateX(-3%);
  }
  20% {
  	transform:translateX(3%);
  }
  30% {
  	transform:translateX(-2%);
  }
  40% {
  	transform:translateX(2%);
  }
  90% {
  	transform:translateX(0%);
  }
  95% {
  	transform:translateX(1%);
  }
  99% {
  	transform:translateX(-1%);
  }
  100% {
  	transform:translateX(0);
  }
}

</style>




// WEBPACK FOOTER //
// src/components/AppListVehicles.vue